import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconTrophyComponent } from "./med-icon-trophy.component";

@NgModule({
  declarations: [
    MedIconTrophyComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconTrophyComponent,
  ],
})
export class MedIconTrophyModule { }
